import {
  getSelectedFarmIdFromStorage,
  getFarmStateFromStorage,
} from "shared/storageUtils";
import {
  HOUR_FORMATS,
  DATE_FORMATS,
  DATE_UNIT,
  DateUtils,
} from "shared/dateUtils";

export const getFarmTimezone = () => {
  const selectedFarm = getSelectedFarm();
  return selectedFarm && selectedFarm.TimezoneFazenda
    ? Number(selectedFarm.TimezoneFazenda)
    : null;
};

export const getSelectedFarm = () => {
  const selectedFarmId = getSelectedFarmIdFromStorage();
  const farmList = getFarmStateFromStorage();

  if (
    selectedFarmId &&
    farmList &&
    farmList.Fazendas &&
    farmList.Fazendas.length > 0
  ) {
    return farmList.Fazendas.find((farm) => farm.IdFazenda === selectedFarmId);
  }
  return null;
};

export const getFarmRegion = () => {
  const selectedFarm = getSelectedFarm();
  return selectedFarm && selectedFarm.Estado ? selectedFarm.Estado : null;
};

export const formatDate = (date, formatPattern) => {
  const farmTimezone = getFarmTimezone();
  if (farmTimezone) {
    return DateUtils.utc(date)
      .add(farmTimezone, DATE_UNIT.HOUR)
      .format(formatPattern || DATE_FORMATS["DD/MM/YYYY"]);
  }
  return DateUtils.parse(date).format(
    formatPattern || DATE_FORMATS["DD/MM/YYYY"]
  );
};

export const formatHour = (hour, formatPattern) => {
  const farmTimezone = getFarmTimezone();
  if (farmTimezone) {
    return DateUtils.utc(hour)
      .add(farmTimezone, DATE_UNIT.HOUR)
      .format(formatPattern || HOUR_FORMATS["HH:mm"]);
  }
  return DateUtils.parse(hour).format(formatPattern || HOUR_FORMATS["HH:mm"]);
};

export const formatTimezone = () => {
  const farmTimezone = getFarmTimezone();
  const farmRegion = getFarmRegion();

  if (farmTimezone && farmRegion) {
    return `(${farmRegion} GMT${farmTimezone})`;
  }
  return "";
};

export const formatDateToFarmTimezone = (date) =>
  `${formatDate(date)} às ${formatHour(date)} ${formatTimezone()}`;

export const parseDateToFarmTimezone = (date) => {
  const farmTimezoneOffset = getFarmTimezone() || 0;
  const userTimezoneOffset = DateUtils.now().utcOffset() / 60;
  const diffTimezoneOffeset = userTimezoneOffset + farmTimezoneOffset;

  return DateUtils.parse(date)
    .add(diffTimezoneOffeset, DATE_UNIT.HOUR)
    .toDate();
};
